import WebApp from '@twa-dev/sdk';

import { isTMA } from './is-tma';

export const setCloudStorageValue = (key: string, value: string) => {
  return new Promise<void>((resolve) => {
    if (!isTMA()) {
      return resolve(localStorage.setItem(key, value));
    }

    try {
      WebApp.CloudStorage.setItem(key, value, (error) => {
        if (error) {
          return resolve(localStorage.setItem(key, value));
        }
        return resolve();
      });
    } catch {
      return resolve(localStorage.setItem(key, value));
    }
  });
};

export const getCloudStorageValue = (key: string) => {
  return new Promise<string | null>((resolve) => {
    const storedValueFromLocalStorage = localStorage.getItem(key);

    if (!isTMA()) {
      return resolve(storedValueFromLocalStorage);
    }

    try {
      WebApp.CloudStorage.getItem(key, (error, storedValue) => {
        if (error) {
          return resolve(storedValueFromLocalStorage);
        }

        if (storedValue === '') return resolve(null);

        return resolve(storedValue ?? null);
      });
    } catch {
      return resolve(localStorage.getItem(key));
    }
  });
};

export const removeCloudStorageValue = (key: string) => {
  return new Promise<void>((resolve) => {
    if (!isTMA()) {
      return resolve(localStorage.removeItem(key));
    }

    try {
      WebApp.CloudStorage.removeItem(key, (error) => {
        if (error) {
          return resolve(localStorage.removeItem(key));
        }
        return resolve();
      });
    } catch {
      return resolve(localStorage.removeItem(key));
    }
  });
};

export const getCloudStorageKeys = (): Promise<string[]> => {
  const getAllKeys = () => {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) keys.push(key);
    }
    return keys;
  };

  return new Promise<string[]>((resolve) => {
    if (!isTMA()) {
      return resolve(getAllKeys());
    }

    try {
      WebApp.CloudStorage.getKeys((error, storedKeys) => {
        if (error) {
          return resolve(getAllKeys());
        } else {
          return resolve(storedKeys || []);
        }
      });
    } catch {
      return resolve(getAllKeys());
    }
  });
};

export const getCloudStorageValues = () => {
  return new Promise<Record<string, string | null>>((resolve) => {
    if (!isTMA()) {
      return resolve({ ...localStorage });
    }

    try {
      void getCloudStorageKeys().then((keys) => {
        WebApp.CloudStorage.getItems(keys, (err, values) => {
          if (err) return resolve({ ...localStorage });

          return resolve(values ?? {});
        });
      });
    } catch {
      return resolve({ ...localStorage });
    }
  });
};

export const removeCloudStorageValues = (keys: string[]): Promise<void> => {
  const removeAllKeys = () => {
    for (const key of keys) {
      localStorage.removeItem(key);
    }
  };

  return new Promise<void>((resolve) => {
    if (!isTMA()) {
      removeAllKeys();
      return resolve();
    }

    try {
      WebApp.CloudStorage.removeItems(keys, (error) => {
        if (error) {
          removeAllKeys();
        }
        return resolve();
      });
    } catch {
      removeAllKeys();
      return resolve();
    }
  });
};
